import { Form as FormikForm } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Scaffold = styled.section`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${({ theme }) => theme.rule.specific.background};
    height: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 18px 16px;
  background-color: ${ColorPalette.HEX.Lotion};

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
    background-color: ${ColorPalette.Transparent};
  }
`;

export const About: any = styled.div`
  padding: 21px 16px;
  border-radius: 16px;
  border: solid 1px ${ColorPalette.HEX.BrightGray};
  background-color: ${ColorPalette.HEX.White};
`;

About.Title = styled.span`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.rule.specific.about.color};
`;

About.Text = styled.p`
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.2px;
  margin: 8px 0px;
  color: ${({ theme }) => theme.rule.specific.about.color};
`;

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Fields = styled.div`
  display: block;
  padding-top: 8px;
`;

export const ButtonArea = styled.div`
  margin-top: auto;
  padding-top: 32px;
`;

export const ConfirmButton = styled(Button)`
  height: 56px;
  font-size: 16px;
  font-weight: 600;
`;

export const List = styled.ol`
  display: flex;

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: center;
  }

  @media ${({ theme }) => theme.device.desktop} {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  min-height: 80px;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  border: 1px ${({ theme }) => theme.rule.ruleList.lightGrey};
  border-style: solid none;
  background-color: ${({ theme }) => theme.rule.ruleList.white};

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 16px;
    border: none;
  }
`;

export const ButtonGhost: any = styled.button`
  display: flex;
  background-color: ${({ theme }) => theme.rule.ruleList.white};
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.rule.ruleList.primary};
  cursor: pointer;
`;

ButtonGhost.Icon = styled.img`
  margin-right: 8px;
`;

export const ButtonContainer = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.usersList.cardBackground};
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
  }
`;

export const StyledButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 28px 5%;
  }
`;
